<div class="button-container">
  <div class="select-container">
    <select (change)="changeRegion($event)">
      @for (region of regions(); track region.id_region) {
        <option [value]="region.path" [selected]="region.id_region === idRegion">
          {{ region.label | translate }}
        </option>
      }
    </select>
  </div>
  <div class="button-group">
    <button class="btn btn-action" (click)="openProgAnnonceModal()">{{ 'button.validateSchedule' | translate }}</button>
    <button class="btn btn-action" (click)="openGestionCirculationModal()">{{ 'button.manageCirculations' | translate }}</button>
    <button class="btn btn-action" (click)="openExportsModal()">{{ 'button.exports' | translate }}</button>
    <button class="btn btn-action" (click)="openLegendModal()">{{ 'button.legend' | translate }}</button>
  </div>
</div>
